import React from 'react';
import { useSelector } from 'react-redux';

import { useCashierWidget } from '../../../../model';

import { wrapper } from './BalanceBreakdown.scss';
import BalanceRecord from './components/BalanceRecord/BalanceRecord';
import OtherBalances from './components/OtherBalances/OtherBalances';

const BalanceBreakdown: React.FC = () => {
  const { widgetSelect } = useCashierWidget();
  const { balances } = useSelector(widgetSelect.get);

  return (
    <>
      <div className={wrapper}>
        {balances?.map((item, index) => (
          <BalanceRecord key={index} multiBalances={balances.length > 1} {...item} />
        ))}
      </div>
      {balances && <OtherBalances balances={balances} />}
    </>
  );
};

export default BalanceBreakdown;
